// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"21b6c947","213":"40f3ca71","239":"c0654964","667":"81f0d491","715":"41c22282"}[chunkId] + ".chunk.js";
};